import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  selectDictContent(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/dict/page',
      method: 'post',
	  data:param
    })
  },
  selectI18n(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/dict/selectI18n',
	  method: 'post',
	  data:param
	})
  },
  selectDictName() {
    return request({
      url: store.getters.getPostUrl + 'mes/dict/All',
      method: 'get'
    })
  },
  insert1(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/dict/insert',
	  method: 'post',
	  data:param
	})
  },
  update1(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/dict/update',
  	  method: 'post',
  	  data:param
  	})
  },
  del1(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/dict/delete',
  	 method: 'get',
  	 params:{'id': param}
  	})
  },
  insertI18n(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/dict/insertI18n',
  	  method: 'post',
  	  data:param
  	})
  },
  updateI18n(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/dict/updateI18n',
  	  method: 'post',
  	  data:param
  	})
  },
  delI18n(param) {
  	return request({
  	 url: store.getters.getPostUrl + 'mes/dict/deleteI18n',
  	 method: 'get',
  	 params:{'id': param}
  	})
  },
  selectParamList1(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/i18n/param',
	  method: 'post',
	  params:{'name': param}
	})
  },
  updateParam(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/i18n/update',
  	  method: 'post',
  	  data: param
  	})
  },
	selectI18n1(param) {
		return request({
		 url: store.getters.getPostUrl + 'mes/dict/i18nPart',
		 method: 'get',
		 data: param
		})
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/dictPage/dictPage.js